export const SET_COOKIE_CONSENT = 'SET_COOKIE_CONSENT'
export const SET_LP_DATA = 'SET_LP_DATA'
export const SET_MENU_MOBILE = 'SET_MENU_MOBILE'
export const SET_CAMPAIGN_DATA = 'SET_CAMPAIGN_DATA'
